export default __webpack_public_path__ + "static/media/wave_four.25645c00.svg";